/**
 * Icône SVG de marque d'une ligne (`apps/web/public/line-icons/<ref>.svg`,
 * D-014). Les fichiers sont nommés par `route_short_name` (« M », « T1 »,
 * « F7 », « 42 »…). Quelques lignes portent un libellé au lieu du code court —
 * on les ramène ici au bon fichier. Tout `<img>` garde un repli texte
 * (`onerror`) pour les ~8 lignes sans asset (Filo'r, Calypso, C, D1/D2…).
 */
const CODE_ALIAS: Record<string, string> = {
  Métro: "M",
  Metro: "M",
  métro: "M",
  Noctambus: "N",
  noctambus: "N",
};

/**
 * Ramène un code de ligne au nom de fichier d'icône (alias inclus). Les
 * `route_short_name` du GTFS Astuce arrivent parfois avec un espace parasite
 * (« `T1 ` » observé en prod) — on le retire pour ne pas fabriquer
 * `/line-icons/T1%20.svg` (404).
 */
export function lineIconCode(code: string): string {
  const trimmed = code.trim();
  return CODE_ALIAS[code] ?? CODE_ALIAS[trimmed] ?? trimmed;
}

/** URL de l'icône SVG bundlée pour un code de ligne. */
export function lineIconUrl(code: string): string {
  return `/line-icons/${encodeURIComponent(lineIconCode(code))}.svg`;
}
